// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__ZRqSa","hero-img":"hero_hero-img__Af1_f","hero-credit-short":"hero_hero-credit-short__c6jFw","hero-img-short":"hero_hero-img-short__EnR9q"};